import { ModuleContainer } from 'components/4-habitats/ModuleContainer';
import { HeadingCard } from 'designsystem/components/3-organisms/HeadingCard';

export const HeadingCardFeature: React.FC<Content.HeadingCard> = ({ content, settings, ...props }) => {
	const { heading } = content?.properties ?? {};
	const { noTopMargin } = settings?.properties ?? {};
	return (
		<ModuleContainer {...settings}>
			<HeadingCard heading={heading} noTopMargin={noTopMargin} {...props} />
		</ModuleContainer>
	);
};
